import { render } from "./FormFieldSet.vue?vue&type=template&id=4fa06b74&scoped=true"
import script from "./FormFieldSet.vue?vue&type=script&lang=js"
export * from "./FormFieldSet.vue?vue&type=script&lang=js"

import "./FormFieldSet.vue?vue&type=style&index=0&id=4fa06b74&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa06b74"]])

export default __exports__